// extracted by mini-css-extract-plugin
export default {"coverContainer":"CoverPage_coverContainer__sjpF5","headerCard":"CoverPage_headerCard__k553s","portrait":"CoverPage_portrait__JLhOm"};